import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

// custom style for typography
const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: bold;
`;

export default function ErrorPage() {
  // custom style for error message div
  const errorPageStyle = {
    background: 'white',
    height: '100vh',
    width: '100%',
    top: '0px',
    zIndex: '99999',
    left: '0px',
    fontWeight: '600',
    display: 'flex',
    alignItems:'center',
    justifyContent: 'center',
  };

  return (
    <div style={{ position: 'absolute', ...errorPageStyle }}>
      <StyledTypography variant='h1'>
        Something went wrong!
        <StyledTypography sx={{textAlign: 'center', marginTop: '10px'}}>
          <Link to='/home'>  <Button variant='contained'>Go to Home</Button> </Link>
        </StyledTypography>
      </StyledTypography>
    </div>
  );
}
